export enum Purpose {
  Cooling,
  Freezing,
  Both,
}
